import { render } from "./makeInvoiceRecords.vue?vue&type=template&id=4e1b7739"
import script from "./makeInvoiceRecords.vue?vue&type=script&lang=js"
export * from "./makeInvoiceRecords.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])